import { useMemo } from 'react';

import { Modal } from '@/components/ui/modal';
import { useGetRolesPermissionsQuery } from '../services/teamApi';
import RolesPermissionTable from './RolesPermissionTable';
import { processPermissionData } from './processPermissionData';

interface RolesAndPermissionsProps {
  show: boolean;
  onDismiss: () => void;
}

const RolesAndPermissions = ({ show, onDismiss }: RolesAndPermissionsProps) => {
  const { data, isLoading } = useGetRolesPermissionsQuery(undefined, {
    skip: !show,
  });

  const { groups, columns } = useMemo(
    () => (data ? processPermissionData(data) : { groups: [], columns: [] }),
    [data],
  );

  return (
    <Modal
      open={show}
      onOpenChange={(open) => !open && onDismiss()}
      title="Roles & Permissions"
      // Override the Modal primitive's defaults so DialogContent doesn't
      // scroll — the inner div below is the scroll container, keeping the
      // title bar pinned and letting the table's sticky <th> top/left
      // anchors resolve to a viewport the user can actually see.
      className="max-w-[min(1400px,95vw)] overflow-hidden"
    >
      <div className="-mx-6 -mb-6 flex-1 min-h-0 overflow-auto border-t border-border">
        <RolesPermissionTable
          columns={columns}
          groups={groups}
          isLoading={isLoading}
        />
      </div>
    </Modal>
  );
};

export default RolesAndPermissions;
